import { render, staticRenderFns } from "./ChartjsHorizontalBarChartLocation.vue?vue&type=template&id=a2e0cbbe&"
import script from "./ChartjsHorizontalBarChartLocation.vue?vue&type=script&lang=js&"
export * from "./ChartjsHorizontalBarChartLocation.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsHorizontalBarChartLocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports